// Английские строки интерфейса. Ключи совпадают с ru.js.
// В русском оригинале местами есть опечатки («Клиета», «Итеграций», «очеридь»);
// здесь они не воспроизводятся.
export default {
  common: {
    all: "All",
    yes: "Yes",
    no: "No",
    save: "Save",
    saving: "Saving…",
    saved: "Saved",
    add: "Add",
    delete: "Delete",
    send: "Send",
    update: "Update",
    loading: "Loading…",
    failed: "Something went wrong",
    notSet: "not set",
    name: "Name",
    enterText: "Enter text",
    activity: "Status",
  },

  region: {
    europe: "Europe",
    australia: "Australia",
    canada: "Canada",
    poland: "Poland",
    germany: "Germany",
    france: "France",
    romania: "Romania",
  },

  nav: {
    telegram: "Telegram",
    telegramAlerts: "Telegram: CR, FTD alerts!",
    telegramReconciliation: "Telegram: Reconciliation",
    rules: "Buyer Guidelines",
    users: "Users",
    addFbId: "Add FB ID",
    teams: "Teams",
    buyerStats: "Buyer Stats",
    countryStats: "Country Stats",
    campaignReport: "Campaign Report",
    clients: "Clients",
    integrations: "Integrations",
    blockedCountries: "Blocked Countries",
    countersHistory: "Counters History",
    leads: "Leads",
    leadsUtm: "Leads UTM",
    leadsQueue: "Queued Leads",
    leadStats: "Lead Stats",
    depositStats: "Deposit Stats",
    sendLead: "Send Lead",
    api: "API",
    spending: "Spending",
  },

  header: {
    queue: "Queue",
    queueDisable: "Turn off the lead distribution queue!",
    queueEnable: "Turn on the lead distribution queue!",
    logout: "Log Out",
  },

  home: {
    title: "Home",
  },

  lead: {
    breadcrumb: "Lead",
    listTitle: "Lead List",
    queueTitle: "Leads Queued for Sending",
    assignManually: "Assign manually",
    byCreatedDate: "Created date",
    bySuccessDate: "Success date",
  },

  stopReason: {
    title: "Why the lead stopped",
    empty: "The distributor recorded no rejection for this lead.",
    integration: "Integration {id}",
    selection: "Filtering",
    lastCheck: "Last check: {date}",
    retry: "Lead queued for retry: {attempts} attempt(s), next one {date}.",
    retryDisabled: "Delayed retry of duplicates is off — the lead will not queue itself.",
  },

  quotas: {
    label: "Teams and shares within the integration",
    hintMode:
      "While “All teams” is set, the integration works as before. “Selected only” — a lead from another team skips this integration and goes to the next suitable one.",
    modeAll: "All teams",
    modeSelected: "Selected only",
    allowWithoutTeam: "Allow leads with no team",
    splitBuyerQuota: "Split the team share between buyers",
    releaseHour: "Release hour (UTC)",
    releaseHourPlaceholder: "none",
    hintRelease:
      "From the release hour on, shares are not checked — any allowed team takes the remaining cap. Team and buyer admission works around the clock. Empty — never release.",
    colAllow: "Allow",
    colTeam: "Team",
    colShare: "Share, %",
    colQuota: "Quota, leads",
    colAcceptedToday: "Accepted today",
    colInProgress: "In progress",
    collapse: "collapse",
    buyers: "buyers",
    loadingBuyers: "Loading buyers…",
    noBuyers: "The team has no buyers.",
    hintBuyers:
      "If nobody is checked inside a team, all of its buyers pass. Check at least one — only the checked ones pass.",
    withoutTeam: "No team",
    allowed: "allowed",
    notAllowed: "not allowed",
    summary: "total share of allowed teams:",
    saveQuotas: "Save quotas",
    warnBlocked: "The integration will stop accepting leads from teams: {teams}.",
    warnAllSelected:
      "“Selected only” will be enabled, but every team is checked — the flow will not change.",
    warnWithoutTeam: "Leads with no team will not pass this integration.",
    warnOverCap:
      "Shares add up to {percent}%, which is above the cap: teams will compete for the same slots.",
    warnUnderCap:
      "{percent}% of the cap is allocated: the remainder is released only after the release hour.",
    warnSplitNoop:
      "Splitting the share between buyers only works in “Selected only” mode — right now it has no effect.",
  },

  validStatuses: {
    label: "Partner valid statuses",
    hint: "Statuses from the partner CRM that we get paid for. A lead in such a status counts as valid in Counters History (the “% Valid” column). FTD leads are always valid. Case does not matter.",
    remove: "Remove {status}",
    placeholder: "Type a status and press Enter",
    seen: "Statuses the partner sent over the last 90 days",
    seenLoading: "— loading…",
    seenEmpty:
      "The partner has not sent any statuses yet. Statuses arrive with the deposit import and, if the partner CRM supports it, with the lead status import.",
  },

  integration: {
    listTitle: "Integration List",
    createBreadcrumb: "Create Integration",
    editBreadcrumb: "Edit Integration",
    costType: "Cost type",
    active: "Active",
    inactive: "Inactive",
    validStatusesFor: "Valid statuses — {name}",
    noAccess: "You have no access to this integration",
    saveFailed: "Could not save, please try again",
    historyBreadcrumb: "History",
    historyTitle: "Counters History",
    validExplainTitle: "How % Valid is calculated",
    validExplain:
      "% Valid = (FTD leads + leads whose partner status is in the valid list) ÷ Success leads of the integration for the selected period × 100. The partner status is the lead's latest status in the partner CRM. The list of valid statuses is set in the integration settings. The Total row covers only integrations that have valid statuses configured. The figure reflects current statuses and may change while the partner keeps updating them.",
    validNotConfigured: "valid statuses not configured",
    validList: "valid: {list}",
    lastWeek: "Last week",
    thisWeek: "This week",
    lastMonth: "Last month",
  },

  user: {
    listTitle: "User List",
    createBreadcrumb: "Create User",
    editBreadcrumb: "Edit User",
  },

  team: {
    listTitle: "Team List",
    createBreadcrumb: "Create Team",
    editBreadcrumb: "Edit Team",
    detailTitle: "Team Members",
  },

  client: {
    breadcrumbTypo: "Clients",
    listTitle: "Client List",
    createBreadcrumb: "Create Client",
    createTitle: "Create Client",
    editBreadcrumb: "Edit Client",
    editTitle: "Edit Client",
  },

  country: {},

  spending: {
    breadcrumb: "Spending",
    title: "Spending List",
    metaTitle: "Spending List",
    uploadOk: "File uploaded",
    uploadError: "Could not read the file",
    downloadError: "Download failed",
  },

  log: {
    breadcrumb: "Log",
    title: "Global Distribution Log",
  },

  report: {
    countryStatsTitle: "Country Stats",
    campaignHint:
      "The report is built by parsing the integration name; the integration type is part of that name",
    integrationType: "Integration type",
  },

  telegram: {
    reconciliationTitle: "Reconciliation",
    applySend: "Apply (send to Telegram)",
    nameContainsPlaceholder: "Name (Integration Name Contains)",
    addFilterSet: "Add a filter set",
  },

  modal: {
    rejectReasonRequired: "Please state the reason for rejection!",
  },

  api: {
    downloadError: "File download failed",
  },

  bayerInfo: {
    breadcrumb: "Buyer Guidelines",
    title: "Buyer Guidelines",
    accessTitle: "1. Registration and access",
    access1: "1. Get a work email address.",
    access2: "2. Register a Telegram account.",
    access3: "3. Register an account in the AdsPower anti-detect browser.",
    access4: "4. Get access to Keitaro.",
    access5: "5. Get access to the Tool (the tracker).",
    access6: "6. Get access to the SPY services.",
    access7: "7. Get a unique Buyer ID. Example: AA88",
    reportTitle: "2. Daily report",
    report1: "1. Get access to the Google Sheet with the daily report.",
    report1Note: "- Fill the report in every morning for the previous day.",
    report2: "2. In the Account ID field:",
    report2a: "Add every new ID you receive.",
    report2b: "Important: do not duplicate IDs (one ID = one row in the report).",
    report2c: "Do not put any characters before the ID.",
    report2d:
      "If Google Sheets turns the ID into a formula automatically, change the cell format to text.",
    report3: "3. The remaining columns are self-explanatory — fill them in by meaning.",
    report4: "4. Campaign Report is a separate report, broken down by campaign.",
    report4Note: "- We will show separately how to fill it in correctly.",
    toolTitle: "3. Working with the Tool",
    tool1: "Every ad account ID you receive must be added to the Tool.",
    tool2: "This is what ties the ID to a specific buyer.",
    campaignTitle: "4. Campaign names",
    campaignFormat: "Campaign name format (the offer name in Keitaro):",
    campaignExampleLabel: "Example:",
    campaignWarning: "Only after that may you start driving traffic!",
    noFbId: "A lead submitted without an FB ID will not be counted towards",
    profit: "profit!",
  },
  static: {
    sendLeadTo: "Send a lead to the API:",
    sendLeadWithName: "Send a lead to the API with a split name:",
  },
};
